<template>
  <b-container>
    <SiteTabs />
    <b-row>
      <b-col><h1 class="text-uppercase">About Us</h1></b-col>
    </b-row>
    <b-row>
      <b-col>
        <p>
          Founded in 2017, Songback was built on the belief that artists are talented and more than good enough, and that it is possible for them to be fairly compensated doing what they love.
        </p>

        <p>
          Songback’s mission is to connect artists with the right audience in meaningful ways, and provide them with the right combination of tools by which they are able to define and experience their own success. We strongly believe this can only be achieved if artists have complete control and flexibility, and are given access to legitimate monetization tools that are relevant in today’s ever-changing environment. We focus on using progressive and innovative methods to help develop and even sustain artists’ music careers.
        </p>

        <p>
          For fans, Songback offers a simple multi-sensory experience that is engaging, fulfilling, and meaningful. Fans customize how they discover and consume music, share up close and personal interactions with artists, and support, or “back” artists directly in multiple ways. As we like to tell all fans — follow the artists you like, and back the ones you love!
        </p>
      </b-col>
    </b-row>
    <b-row class="py-4 my-4">
      <b-col class="text-center">
        <h2>WELCOME TO THE SONGBACK EXPERIENCE!</h2>
      </b-col>
    </b-row>
    <b-row class="py-4 my-4">
      <b-col class="text-center">
        <p>
          Contact Information:
        </p>
        <p>
          Songback, LLC <br>
          P.O. Box 18011 <br>
          Irvine, CA 92623
        </p>
        <a href="mailto:support@songback.com">support@songback.com</a>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }
</style>

<script>
import SiteTabs from '@/components/widgets/SiteTabs'

export default {
  components: {
    SiteTabs
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/site/About.vue